import React from 'react';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { CurrencyAmount } from '@cowbell/ui/core';
import { Grid, Box, Card, Typography, Divider, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import EndorsementHeader from '../../agencies/endorsement/components/EndorsementHeader';
import _config from '../../../themes/_base/_config';
import CbButton from '../../../components/Buttons/CbButton';
import { withShowable } from '../../_global/lib/withShowable';

import {
  generateAIText,
  generateCoverageText,
  getConsolidatesKeys,
} from '../../_global/endorsements/endorsement.utils';
import { toUniversalUtcDate } from '../../../utils/date.utils';

const PaymentSummary = ({ quote, onSubmit }: any) => {
  const classes = useStyles();
  const history = useHistory();
  const { palette } = useTheme();

  const firmo = _.get(quote, 'firmographicData');
  const headerData = {
    companyName: _.get(quote, 'companyName'),
    naicsCode: _.get(firmo, 'naicsCode'),
    primaryIndustry: _.get(firmo, 'primaryIndustry'),
  };

  const { coverageText, isAIApplicable, consolidatedKeys } =
    React.useMemo(() => {
      return {
        coverageText: generateCoverageText(quote),
        isAIApplicable: generateAIText(quote),
        consolidatedKeys: getConsolidatesKeys(quote),
      };
    }, [quote]);

  const coverageConsolidatedKeys = consolidatedKeys.filter(
    (k) => k != 'additionalInsureds'
  );

  const handleNextClick = () => {
    if (typeof onSubmit === 'function') {
      onSubmit();
    }
  };

  return (
    <Card style={{ padding: '1.6666666667rem' }}>
      <EndorsementHeader data={headerData} />

      <Divider className={classes.dividerStyle} />

      <Grid item container xs={12}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="space-between"
            padding="0 2em"
            marginTop="1em"
          >
            <Typography className={classes.endorsementText}>
              PAYMENT SUMMARY
            </Typography>
            <Box display="flex">
              <Typography className={classes.endorse}>
                Endorsement Start Date:{' '}
              </Typography>
              <Typography className={classes.endorsementStartDate}>
                {toUniversalUtcDate(quote?.initialRequestData.effectiveDate)}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <SummaryRow
        title="Insured Information"
        status="Updated"
        show={quote?.coveragesupdated?.includes('insuredInfo')}
      />

      <SummaryRow
        title="Coverage/Limits"
        status={coverageText}
        show={coverageText !== 'None' && coverageConsolidatedKeys?.length > 0}
      />
      <SummaryRow
        title="Additional Insured"
        status={isAIApplicable}
        show={isAIApplicable !== 'None'}
      />

      <SummaryRow
        title="Endorsement Payment"
        status={
          <CurrencyAmount
            amount={quote.totalPremium}
            currency={quote.currency}
          />
        }
        style={{
          backgroundColor: palette.background.uniqueRow,
        }}
      />
      <Grid xs={12}>
        <Divider className={classes.divider} />
        <Box className={classes.editSection}>
          <CbButton
            styleName="cancel"
            buttonText="Cancel"
            style={{ marginLeft: '1.66rem' }}
            onClick={() => history.push('/customer/policies')}
          />
          <CbButton
            styleName="ctaButton"
            buttonText="Next"
            style={{ marginLeft: '1.66rem' }}
            onClick={handleNextClick}
          />
        </Box>
      </Grid>
    </Card>
  );
};

// @ts-expect-error TS(2339): Property 'title' does not exist on type '{}'.
const SummaryRow = withShowable(({ title, status, ...props }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.endorsement} {...props}>
      <Typography className={classes.endorsementText} {...props}>
        {title}
      </Typography>
      <Typography className={classes.endorsementText} {...props}>
        {status}
      </Typography>
    </Grid>
  );
});

const useStyles = makeStyles(({ palette, config }) => ({
  divider: {
    marginTop: '1em',
  },
  dividerStyle: {
    margin: '1.33rem 2rem',
  },
  AiDivider: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  editSection: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2rem',
  },
  AI: {
    fontWeight: 'normal',
    padding: '0 2rem',
    fontSize: config.textSizes.primer,
    color: palette.primary.contrastText,
  },
  endorsement: {
    display: 'flex',
    margin: '1em 2em',
    padding: '0.5em 2em',
    backgroundColor: palette.background.customTable,
    borderRadius: 5,
    lineHeight: 1.4,
    justifyContent: 'space-between',
  },
  endorsementText: {
    color: palette.primary.contrastText,
    fontSize: config.textSizes.paragon,
    fontWeight: config.weights.bold,
  },
  endorsementStartDate: {
    color: config.colors.cowbellBlue,
    paddingLeft: '1rem',
    fontSize: config.textSizes.paragon,
    fontWeight: config.weights.bold,
  },
  endorse: {
    color: palette.primary.contrastText,
    fontSize: config.textSizes.paragon,
    fontWeight: config.weights.bold,
  },
  endorsementPayment: {
    backgroundColor: _config.colors.darkGreyActive,
  },
}));

export default PaymentSummary;
